import { Vorgang } from '../types';
import { Gutachtenart } from './constants';

export const sindAlleUnterschriftenVollstaendig = (vorgang: Vorgang) => {
  let signaturesComplete = false;
  if (vorgang.agbV2) {
    signaturesComplete = Boolean(vorgang.unterschriften?.dsgvoV2?.key) && Boolean(vorgang.unterschriften?.widerrufsbelehrung?.key);
    if (vorgang?.gutachtenart !== Gutachtenart.REPARATURNACHWEIS) {
      signaturesComplete = signaturesComplete && Boolean(vorgang.unterschriften?.his?.key);
    }
    if (vorgang?.gutachtenart === Gutachtenart.FAHRZEUGBEWERTUNG) {
      signaturesComplete = signaturesComplete && Boolean(vorgang.unterschriften?.auftragZurErstellungFahrzeugbewertung?.key);
    } else if (vorgang?.gutachtenart === Gutachtenart.REPARATURNACHWEIS) {
      signaturesComplete =
        signaturesComplete &&
        Boolean(vorgang.unterschriften?.auftragZurErstellungReparaturnachweis?.key) &&
        Boolean(vorgang.unterschriften?.fahrtkostenvereinbarungReparaturnachweis?.key) &&
        Boolean(vorgang.unterschriften?.regressansprueche?.key) &&
        Boolean(vorgang.unterschriften?.angebotZurAbtretung?.key) &&
        Boolean(vorgang.unterschriften?.zahlungsanweisung?.key);
    } else {
      signaturesComplete =
        signaturesComplete &&
        Boolean(vorgang.unterschriften?.auftragZurErstellungGutachten?.key) &&
        Boolean(vorgang.unterschriften?.fahrtkostenvereinbarungGutachten?.key) &&
        Boolean(vorgang.unterschriften?.nachbesichtigung?.key) &&
        Boolean(vorgang.unterschriften?.angebotZurAbtretung?.key) &&
        Boolean(vorgang.unterschriften?.regressansprueche?.key) &&
        Boolean(vorgang.unterschriften?.zahlungsanweisung?.key);
    }
  } else {
    signaturesComplete = Boolean(vorgang.unterschriften?.dsgvo?.key);
    if (vorgang?.gutachtenart !== Gutachtenart.REPARATURNACHWEIS) {
      signaturesComplete = signaturesComplete && Boolean(vorgang.unterschriften?.his?.key);
    }
    if (vorgang?.gutachtenart === Gutachtenart.FAHRZEUGBEWERTUNG) {
      signaturesComplete = signaturesComplete && Boolean(vorgang.unterschriften?.auftragsbestaetigung?.key);
    } else {
      signaturesComplete = signaturesComplete && Boolean(vorgang.unterschriften?.abtretungserklaerung?.key);
    }
  }
  return signaturesComplete;
};

export const holeFehlendeUnterschriftenTexte = (vorgang: Vorgang) => {
  const unterschriften = [];
  if (vorgang.agbV2) {
    if (!vorgang.unterschriften?.dsgvoV2?.key) {
      unterschriften.push('die Erklärung zur DSGVO');
    }
    if (!vorgang.unterschriften?.widerrufsbelehrung?.key) {
      unterschriften.push('die Widerrufsbelehrung');
    }
    if (vorgang?.gutachtenart !== Gutachtenart.REPARATURNACHWEIS && !vorgang.unterschriften?.his?.key) {
      unterschriften.push('HIS');
    }
    if (vorgang?.gutachtenart === Gutachtenart.FAHRZEUGBEWERTUNG) {
      if (!vorgang.unterschriften?.auftragZurErstellungFahrzeugbewertung?.key) {
        unterschriften.push('der Auftrag zur Erstellung einer Fahrzeugbewertung');
      }
    } else if (vorgang?.gutachtenart === Gutachtenart.REPARATURNACHWEIS) {
      if (!vorgang.unterschriften?.auftragZurErstellungReparaturnachweis?.key) {
        unterschriften.push('der Auftrag zur Erstellung einer Reparaturbestätigung nach Instandsetzung eines Fahrzeugs');
      }
      if (!vorgang.unterschriften?.fahrtkostenvereinbarungReparaturnachweis?.key) {
        unterschriften.push('die Fahrtkostenvereinbarung zur Reparaturbestätigung');
      }
      if (!vorgang.unterschriften?.regressansprueche?.key) {
        unterschriften.push('das Regressansprüche Abtretungsformular');
      }
      if (!vorgang.unterschriften?.zahlungsanweisung?.key) {
        unterschriften.push('die Zahlungsanweisung');
      }
    } else {
      if (!vorgang.unterschriften?.auftragZurErstellungGutachten?.key) {
        unterschriften.push('der Auftrag zur Erstellung eines Schadengutachtens');
      }
      if (!vorgang.unterschriften?.fahrtkostenvereinbarungGutachten?.key) {
        unterschriften.push('die Fahrtkostenvereinbarung zur Gutachtenerstellung');
      }
      if (vorgang.besichtigungen.items.length > 1 && !vorgang.unterschriften?.nachbesichtigung?.key) {
        unterschriften.push('die Nachbesichtigung');
      }
      if (!vorgang.unterschriften?.angebotZurAbtretung?.key) {
        unterschriften.push('das Angebot zur Abtretung');
      }
      if (!vorgang.unterschriften?.regressansprueche?.key) {
        unterschriften.push('das Regressansprüche Abtretungsformular');
      }
      if (!vorgang.unterschriften?.zahlungsanweisung?.key) {
        unterschriften.push('die Zahlungsanweisung');
      }
    }
  } else {
    if (!vorgang.unterschriften?.dsgvo?.key) {
      unterschriften.push('die Erklärung zur DSGVO');
    }
    if (vorgang?.gutachtenart === Gutachtenart.FAHRZEUGBEWERTUNG) {
      if (!vorgang.unterschriften?.auftragsbestaetigung?.key) {
        unterschriften.push('die Auftragsbestätigung');
      }
    } else {
      if (!vorgang.unterschriften?.abtretungserklaerung?.key) {
        unterschriften.push('die Abtretungserklärung');
      }
    }
  }
  return unterschriften;
};
